import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PartnerUIHelpers";

const PartnerUIContext = createContext();

export function usePartnerUIContext() {
  return useContext(PartnerUIContext);
}

export const PartnerUIConsumer = PartnerUIContext.Consumer;

export function PartnerUIProvider({ partnerUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initPartner = {
    name: "",
    access: [],
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initPartner,
    newPartnerButtonClick: partnerUIEvents.newPartnerButtonClick,
    openEditPartnerPage: partnerUIEvents.openEditPartnerPage,
  };

  return (
    <PartnerUIContext.Provider value={value}>
      {children}
    </PartnerUIContext.Provider>
  );
}
